var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartBid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.095,
    height: 34.095,
    viewBox: "0 0 34.095 34.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6220",
    "data-name": "Group 6220",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6212",
    "data-name": "Group 6212",
    transform: "translate(14.612 4.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    "data-name": "Path 3684",
    d: "M1219.076,550.423c-5.462,0-9.741-2.5-9.741-5.682a.812.812,0,1,1,1.623,0c0,2.2,3.717,4.059,8.118,4.059s8.118-1.859,8.118-4.059a.812.812,0,1,1,1.623,0C1228.817,547.927,1224.538,550.423,1219.076,550.423Z",
    transform: "translate(-1209.335 -543.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6213",
    "data-name": "Group 6213",
    transform: "translate(14.612 8.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    d: "M1219.076,555.423c-5.462,0-9.741-2.5-9.741-5.682a.812.812,0,1,1,1.623,0c0,2.2,3.717,4.059,8.118,4.059s8.118-1.859,8.118-4.059a.812.812,0,1,1,1.623,0C1228.817,552.927,1224.538,555.423,1219.076,555.423Z",
    transform: "translate(-1209.335 -548.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6214",
    "data-name": "Group 6214",
    transform: "translate(19.969 12.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M1220.318,560.423a16.226,16.226,0,0,1-3.76-.429.812.812,0,1,1,.376-1.579,14.606,14.606,0,0,0,3.384.384c4.4,0,8.118-1.859,8.118-4.059a.812.812,0,1,1,1.623,0C1230.06,557.927,1225.78,560.423,1220.318,560.423Z",
    transform: "translate(-1215.934 -553.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6215",
    "data-name": "Group 6215",
    transform: "translate(19.969 17.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M1220.318,565.423a16.236,16.236,0,0,1-3.76-.429.812.812,0,1,1,.376-1.579,14.609,14.609,0,0,0,3.384.384c4.4,0,8.118-1.859,8.118-4.059a.812.812,0,1,1,1.623,0C1230.06,562.927,1225.78,565.423,1220.318,565.423Z",
    transform: "translate(-1215.934 -558.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6216",
    "data-name": "Group 6216",
    transform: "translate(0 14.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M1201.076,575.412c-5.462,0-9.741-2.5-9.741-5.682v-8.118c0-3.186,4.279-5.682,9.741-5.682s9.741,2.5,9.741,5.682v8.118C1210.818,572.915,1206.538,575.412,1201.076,575.412Zm0-17.859c-4.4,0-8.118,1.859-8.118,4.059v8.118c0,2.2,3.717,4.059,8.118,4.059s8.118-1.859,8.118-4.059v-8.118C1209.194,559.411,1205.477,557.553,1201.076,557.553Z",
    transform: "translate(-1191.335 -555.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6217",
    "data-name": "Group 6217",
    transform: "translate(0 19.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M1201.076,568.423c-5.462,0-9.741-2.5-9.741-5.682a.812.812,0,0,1,1.624,0c0,2.2,3.717,4.059,8.118,4.059s8.118-1.859,8.118-4.059a.812.812,0,0,1,1.624,0C1210.818,565.927,1206.538,568.423,1201.076,568.423Z",
    transform: "translate(-1191.335 -561.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6218",
    "data-name": "Group 6218",
    transform: "translate(0 23.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M1201.076,573.423c-5.462,0-9.741-2.5-9.741-5.682a.812.812,0,0,1,1.624,0c0,2.2,3.717,4.059,8.118,4.059s8.118-1.859,8.118-4.059a.812.812,0,0,1,1.624,0C1210.818,570.927,1206.538,573.423,1201.076,573.423Z",
    transform: "translate(-1191.335 -566.929)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6219",
    "data-name": "Group 6219",
    transform: "translate(14.612 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M1219.076,565.529a16.221,16.221,0,0,1-3.757-.428.812.812,0,1,1,.376-1.579,14.638,14.638,0,0,0,3.381.383c4.4,0,8.118-1.859,8.118-4.059V543.611c0-2.2-3.717-4.059-8.118-4.059s-8.118,1.859-8.118,4.059v8.118a.812.812,0,1,1-1.623,0v-8.118c0-3.186,4.279-5.682,9.741-5.682s9.741,2.5,9.741,5.682v16.236C1228.817,563.033,1224.538,565.529,1219.076,565.529Z",
    transform: "translate(-1209.335 -537.929)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBid);
export default __webpack_public_path__ + "static/media/startBid.ca9b1b40fe1b949671ef39f0ce490607.svg";
export { ForwardRef as ReactComponent };